import { makeAutoObservable, runInAction } from 'mobx';
import { RootStore } from 'store/rootStore';
import { RFQChecklist } from 'types/enrollmentService';
import { Group } from 'types/groupService';
import { getCart } from 'api/operations/cartServiceV2';
import { Cart } from 'types/cartServiceV2';
import { getProposalChecklist } from 'api/operations/enrollmentService';

export default class RFQProposalSidebarStore {
  rootStore: RootStore;
  loading = false;
  checklist: RFQChecklist | null = null;
  cart: Cart | null = null;
  group: Group | null = null;

  public async getRFQProposalSidebarInfo(cartId: string, periodId: string): Promise<void> {
    const cart = await getCart(cartId);
    await runInAction(async () => {
      this.cart = cart;
      await this.rootStore.groupStore.getGroupById(cart.groupId);
      await runInAction(async () => {
        this.group = this.rootStore.groupStore.group;

        // Id period id exists initiate rfq was submitted
        if (periodId) {
          const res = await getProposalChecklist(periodId, cartId);
          runInAction(() => {
            if (res) this.checklist = res.data.getProposalChecklist;
          });
        }
      });
    });
  }

  public resetSidebarInfo(): void {
    this.group = null;
    this.checklist = null;
    this.cart = null;
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
